import request from '@/utils/service'

export function getSetting(data) {
  return request({ url: '/setting/list', params: data })
}

export function submitSetting(data) {
  return request({ url: '/setting/update', data })
}

export function setCouponsRule(data) {
  return request({ url: '/coupon/giveoutRule/updateRule', data })
}
